/**
 * Instante UTC para el comprobante de /confirm-turn.
 * No usar hour.$d: con utcOffset, $d guarda la hora de pared como Date local
 * del dispositivo. En otra zona distinta a la del centro, toISOString() de $d
 * no es el turno guardado.
 */
export function normalizeConfirmHour(hour) {
  if (hour == null || hour === '') return hour;
  if (hour.$isDayjsObject) {
    return new Date(hour.valueOf()).toISOString();
  }
  return hour;
}
